import CheckBox from "../CheckBox/CheckBox";
import "./Switcher.scss";

export default class Switcher extends CheckBox {
	constructor(settings?: object)
	{
		super(settings);
	}

	_componentInit()
	{
		this._initComponent("<div class='checkbox font_subheading switcher'>" +
			 "<span class='icon'>" +
			 "<span class='ic_toggle_off checkboxoff check-box-ic'></span>" +
			 "<span class='ic_toggle_on checkboxon check-box-ic'></span>" +
			 "</span>" +
			 "<span class='content'></span>" +
			 "</div>");
	}
}